import { Text } from '@lmc/ui-kit/src/general'
import { Popover } from 'antd'
import { useTranslation } from 'react-i18next'
import useClockInWarnings from 'screens/Rostering/hooks/useClockInWarnings'
import { WarningIcon } from 'screens/Rostering/RotaBuilder/common/components/icons'
import type { ClockInTeamMember } from 'screens/Rostering/types'
import styled from 'styled-components'

type ClockInWarningsPopoverProps = {
  warnings: ClockInTeamMember['warnings']
}

const ClockInWarningsPopover = ({ warnings }: ClockInWarningsPopoverProps) => {
  const { t } = useTranslation()

  const clockInWarnings = useClockInWarnings(warnings)

  if (!clockInWarnings?.length) return null

  return (
    <Popover
      placement="bottomRight"
      showArrow
      trigger="hover"
      arrow={{ pointAtCenter: true }}
      content={
        <Container>
          <LightText weight="medium" level={2}>
            {t('WARNINGS')}
          </LightText>
          {clockInWarnings.map((warning) => (
            <WarningContainer key={warning}>
              <WarningIcon />
              <Text>{t(warning)}</Text>
            </WarningContainer>
          ))}
        </Container>
      }
    >
      <IconContainer>
        <WarningIcon />
      </IconContainer>
    </Popover>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 4px;
`
const LightText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color5};
`
const WarningContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`
const IconContainer = styled.div`
  display: flex;
  align-items: center;
`

export default ClockInWarningsPopover
